import React, { useEffect } from 'react';
import { PlusOutlined, FolderOutlined } from '@ant-design/icons';
import { Button, Card, Image, Typography, Space, Tag } from 'antd';
import { useStorage } from 'providers/StorageProvider';
import useAuth from 'hooks/useAuth';
import useFiles from 'hooks/useFiles';
import useTenantFlags from 'hooks/useTenantFlags';
import FileGrid from '../../../components/global/FileGrid/FileGrid';

const { Title } = Typography;

const CarpetaDigital = ({ id }) => {
  const {
    getCarpetaDigital,
    createCarpetaDigital,
    carpetaDigital,
    openCreate,
    openEdit,
    openDelete,
    loadingGetCarpetaDigital,
    loadingCreateCarpetaDigital,
  } = useStorage();

  const { user } = useAuth();
  const { readOnly } = useTenantFlags();
  const { getImagePreviewProps } = useFiles();

  useEffect(() => {
    getCarpetaDigital(id);
  }, [getCarpetaDigital, id]);

  // Handlers para el FileGrid
  const handleEdit = (file) => {
    openEdit(file, carpetaDigital);
  };

  const handleDelete = (file) => {
    openDelete(file.id, carpetaDigital);
  };

  const handleAddFile = () => {
    openCreate(carpetaDigital);
  };

  return (
    <Card
      title={
        <Space>
          <FolderOutlined style={{ color: '#52c41a' }} />
          <Title level={4} style={{ margin: 0 }}>
            Carpeta Digital
          </Title>
          {carpetaDigital && (
            <Tag color="green">
              {carpetaDigital.Files?.length || 0} archivo
              {carpetaDigital.Files?.length !== 1 ? 's' : ''}
            </Tag>
          )}
        </Space>
      }
      loading={loadingGetCarpetaDigital}
      extra={
        readOnly ? null : !carpetaDigital ? (
          <Button
            type="primary"
            loading={loadingCreateCarpetaDigital}
            onClick={() => createCarpetaDigital(id)}
            icon={<FolderOutlined />}
            size="large"
          >
            Crear Carpeta
          </Button>
        ) : (
          <Button
            type="primary"
            onClick={() => openCreate(carpetaDigital)}
            icon={<PlusOutlined />}
            size="large"
          >
            Añadir Archivo
          </Button>
        )
      }
      style={{ borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}
    >
      <FileGrid
        files={carpetaDigital?.Files || []}
        onEdit={readOnly ? undefined : handleEdit}
        onDelete={readOnly ? undefined : handleDelete}
        onAddFile={readOnly ? undefined : handleAddFile}
        user={user}
        folderName="Carpeta Digital"
        folderColor="#52c41a"
        emptyMessage="No hay archivos en esta carpeta digital"
        showAddButton={!readOnly && !!carpetaDigital}
      />
      <Image {...getImagePreviewProps()} />
    </Card>
  );
};

export default CarpetaDigital;
